var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletConnectLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3A99FB",
    d: "M12.194 16.24c6.52-6.386 17.091-6.386 23.62 0l.785.768a.8.8 0 0 1 0 1.156l-2.682 2.632c-.16.16-.43.16-.59 0l-1.08-1.055c-4.548-4.454-11.93-4.454-16.477 0l-1.155 1.131c-.16.16-.43.16-.59 0l-2.692-2.632a.8.8 0 0 1 0-1.156l.86-.843Zm29.172 5.433 2.387 2.337a.8.8 0 0 1 0 1.156L32.98 35.72a.845.845 0 0 1-1.18 0l-7.652-7.492a.22.22 0 0 0-.296 0L16.21 35.72a.845.845 0 0 1-1.18 0L4.246 25.174a.8.8 0 0 1 0-1.155l2.387-2.337a.845.845 0 0 1 1.181 0l7.652 7.491a.22.22 0 0 0 .295 0l7.643-7.491a.845.845 0 0 1 1.181 0l7.652 7.491a.22.22 0 0 0 .295 0l7.652-7.491a.838.838 0 0 1 1.18-.009Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletConnectLogo);
export default __webpack_public_path__ + "static/media/walletConnectLogo.460e20d86444f0bba25613e738f4a394.svg";
export { ForwardRef as ReactComponent };